import React from 'react';

interface ErrorThrowerProps {
  error: Error | null;
  children: React.ReactNode;
}

/**
 * Component that throws an error during render if an error is provided.
 * This allows async errors (like API failures) to be caught by Error Boundaries.
 *
 * Usage:
 * ```tsx
 * const [apiError, setApiError] = useState<Error | null>(null);
 *
 * // In async function
 * try {
 *   await apiCall();
 * } catch (error) {
 *   setApiError(error);
 * }
 *
 * // In render
 * return (
 *   <ErrorThrower error={apiError}>
 *     <YourAppContent />
 *   </ErrorThrower>
 * );
 * ```
 */
const ErrorThrower: React.FC<ErrorThrowerProps> = ({ error, children }) => {
  if (error) {
    // Throw during render - this will be caught by Error Boundary
    throw error;
  }

  return <>{children}</>;
};

export default ErrorThrower;
